import { useCallback, useMemo } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from '../../../../src/theme/useTheme';
import { getWcColors } from '../../../../components/worldcup/MatchPickStats/matchPickStats.helper';
import { getMatchPickStatsStyles } from '../../../../components/worldcup/MatchPickStats/MatchPickStatsScreen.styles';
import { MatchPickStatsScreen } from '../../../../components/worldcup/MatchPickStats/MatchPickStatsScreen';

export default function WorldCupMatchStatsRoute() {
  const router = useRouter();
  const theme = useTheme();
  const colors = useMemo(() => getWcColors(theme), [theme]);
  const styles = useMemo(() => getMatchPickStatsStyles(colors), [colors]);
  const { matchId } = useLocalSearchParams<{ matchId: string }>();
  const id = typeof matchId === 'string' ? matchId : '';

  const handleBack = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <SafeAreaView style={styles.routeSafeArea} edges={['top', 'left', 'right', 'bottom']}>
      <MatchPickStatsScreen matchId={id} onBack={handleBack} onEditPick={handleBack} />
    </SafeAreaView>
  );
}
